import { useMediaQuery } from "hooks/useMediaQuery";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ImageSourcePropType, StyleSheet, View } from "react-native";

import { AnalyticsConst, AnalyticsInstance } from "gyg_common";
import cateringIcon from "gyg_common/components/assets/icons/services/catering.png";
import deliveryWithUber from "gyg_common/components/assets/icons/services/delivery_with_uber_icon.png";
import deliveryIcon from "gyg_common/components/assets/icons/services/icon_delivery.png";
import pickupIcon from "gyg_common/components/assets/icons/services/icon_pickup.png";
import PrimaryYellowButton from "gyg_common/components/Buttons/PrimaryYellowButton";
import { SetupScreenComponent } from "gyg_common/components/OrderSetup/OrderSetupFlowContent";
import { Spacing } from "gyg_common/components/styles/number";
import ToggleSelect, {
  ActiveTabType,
} from "gyg_common/components/ToggleSelect";
import {
  CollectionType,
  ModalState,
  OrderType,
} from "gyg_common/redux_store/order/models";

const styles = StyleSheet.create({
  buttonContainer: {
    marginBottom: Spacing.Medium,
    marginHorizontal: Spacing.MediumThick,
  },
  mobile: {
    marginHorizontal: Spacing.Light,
  },
  alert: {
    alignItems: "center",
    display: "flex",
    color: "black",
    padding: 15,
    borderRadius: 5,
    borderColor: "#000",
    fontFamily: "Sini-Bold",
    fontSize: 22,
    marginRight: 40,
    marginLeft: 40,
    marginTop: 0,
    marginBottom: 40,
  },
});

const OrderCollectionCategory: React.FC<SetupScreenComponent<ModalState>> = ({
  state,
  onChangeCollectionType,
}) => {
  const { t } = useTranslation();
  const { isTabletScreen } = useMediaQuery();

  const onPickupPress = () => {
    //reset previous store selection to allow nearest store logic to proceed and always look for nearest store instead of previously selected
    state.ChosenStore = undefined;
    AnalyticsInstance.trackEvent(AnalyticsConst.Events.PickupSelection, {});
    state.OrderType = OrderType.STANDARD;
    onChangeCollectionType(CollectionType.PICK_UP, state);
  };
  const onCateringPickupPress = () => {
    //reset previous store selection to allow nearest store logic to proceed and always look for nearest store instead of previously selected
    state.ChosenStore = undefined;
    AnalyticsInstance.trackEvent(AnalyticsConst.Events.PickupSelection, {});
    state.OrderType = OrderType.CATERING;
    onChangeCollectionType(CollectionType.PICK_UP, state);
  };

  const onDeliveryPress = () => {
    AnalyticsInstance.trackEvent(AnalyticsConst.Events.DeliverySelection, {});
    state.OrderType = OrderType.STANDARD;
    onChangeCollectionType(CollectionType.DELIVERY, state);
  };

  const onCateringDeliveryPress = () => {
    AnalyticsInstance.trackEvent(AnalyticsConst.Events.DeliverySelection, {});
    state.OrderType = OrderType.CATERING;
    onChangeCollectionType(CollectionType.DELIVERY, state);
  };

  const [activeTab, setActiveTab] = useState<string>(
    state.OrderType === OrderType.CATERING
      ? ActiveTabType.RIGHT
      : ActiveTabType.LEFT
  );
  return (
    <>
      <View style={styles.buttonContainer}>
        <ToggleSelect
          activeTab={activeTab as ActiveTabType}
          leftTitle={"Personal"}
          rightTitle={"Catering (Beta)"}
          onUpdateTab={(activeTab) => {
            const newActiveTab =
              activeTab === ActiveTabType.LEFT
                ? ActiveTabType.RIGHT
                : ActiveTabType.LEFT;
            setActiveTab(newActiveTab);
          }}
        />
      </View>

      {activeTab === ActiveTabType.LEFT && (
        <>
          <View
            style={[styles.buttonContainer, !isTabletScreen && styles.mobile]}>
            <PrimaryYellowButton
              icon={pickupIcon as ImageSourcePropType}
              buttonName={t("OrderManagement:pickup")}
              fontSize={isTabletScreen ? 28 : 20}
              iconWidth={35}
              onClick={onPickupPress}
            />
          </View>
          <View
            style={[styles.buttonContainer, !isTabletScreen && styles.mobile]}>
            <PrimaryYellowButton
              icon={deliveryIcon as ImageSourcePropType}
              rightIcon={deliveryWithUber as ImageSourcePropType}
              buttonName={t("OrderManagement:delivery")}
              fontSize={isTabletScreen ? 28 : 19}
              iconWidth={45}
              rightIconWidth={isTabletScreen ? 120 : 90}
              onClick={onDeliveryPress}
            />
          </View>
        </>
      )}

      {activeTab === ActiveTabType.RIGHT && (
        <>
          <View>
            <div style={styles.alert}>
              <ul>
                <li>
                  Catering requires $400 minimum value and 48hrs minimum notice.
                </li>
              </ul>
            </div>
          </View>
          <View
            style={[styles.buttonContainer, !isTabletScreen && styles.mobile]}>
            <PrimaryYellowButton
              icon={pickupIcon as ImageSourcePropType}
              buttonName={t("OrderManagement:pickup")}
              fontSize={isTabletScreen ? 28 : 20}
              iconWidth={35}
              onClick={onCateringPickupPress}
            />
          </View>
          <View
            style={[styles.buttonContainer, !isTabletScreen && styles.mobile]}>
            <PrimaryYellowButton
              icon={cateringIcon as ImageSourcePropType}
              rightIcon={deliveryWithUber as ImageSourcePropType}
              buttonName={t("OrderManagement:delivery")}
              fontSize={isTabletScreen ? 28 : 19}
              iconWidth={45}
              rightIconWidth={isTabletScreen ? 120 : 90}
              onClick={onCateringDeliveryPress}
            />
          </View>
        </>
      )}
    </>
  );
};

export default OrderCollectionCategory;
